import React, {PureComponent} from 'react';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';

import UnstyledButton from '../Button';
import Icon from '../Icon';

class Pagination extends PureComponent {
  renderPaginator = isSmallScreen => {
    const {mini} = this.props;

    if (mini) {
      // The mini prop will force the component to always take the mobile form.
      isSmallScreen = true;
    }

    const showPrevNext = !isSmallScreen;
    const buffer = isSmallScreen ? 1 : 2;

    return <Paginator {...this.props} buffer={buffer} showPrevNext={showPrevNext} />;
  }
  
  render() {
    return <MediaQuery maxWidth={800} children={this.renderPaginator} />;
  }
}

function Paginator({page, itemsPerPage, totalItems, onClick, disabled, buffer = 2, showPrevNext = true}) {
  const numPages = Math.ceil(totalItems / itemsPerPage);
  let pages = [];

  if (numPages < 2) {
    return null; // No pagination required. There is only a single page.
  }

  // Starting pages
  for (let i = 1; i <= buffer; i++) {
    if (isValidPage(i, numPages, pages)) {
      pages.push(i);
    }
  }

  // Middle pages
  for (let i = page - buffer; i <= page + buffer; i++) {
    if (isValidPage(i, numPages, pages)) {
      pages.push(i);
    }
  }

  // End pages
  for (let i = numPages - buffer + 1; i <= numPages; i++) {
    if (isValidPage(i, numPages, pages)) {
      pages.push(i);
    }
  }

  return (
    <div>
      <Button tertiary disabled={page === 1 || disabled} onClick={() => onClick(page - 1)}>
        <Icon name="chevron-left" />{showPrevNext && ' Previous'}
      </Button>
      {pages.map((p, i) => {
        const nextPage = pages[i + 1] || p + 1;
        
        return [
          <Button key={p} primary={page === p} tertiary={page !== p} shadow={false} disabled={disabled} onClick={() => page !== p && onClick(p)}>
            {p.toLocaleString()}
          </Button>,
          p !== nextPage - 1 && (
            <Button key={p + 1} tertiary readOnly>...</Button>
          )
        ];
      })
      .reduce((flat, next) => flat.concat(next), [])
      .filter(Boolean)}
      <Button tertiary onClick={() => onClick(page + 1)} disabled={page === numPages || disabled}>
        {showPrevNext && 'Next '}<Icon name="chevron-right" />
      </Button>
    </div>
  );
}

function isValidPage(page, numPages, pages) {
  return page > 0 && page <= numPages && pages.indexOf(page) < 0;
}

const Button = styled(UnstyledButton)`
  min-width: 2.25rem;
  border-radius: 2.5rem;
`;

export default Pagination;